import Requests from './requests'

export default class UserPerms extends Requests {

  list () {
    return this._getAll()
  }

  create (perm) {
    return this._create(perm)
  }

  update (perm) {
    return this._update(perm)
  }

  delete (permId) {
    return this._delete(permId)
  }

}



// WEBPACK FOOTER //
// ./src/userPerms.js